import { Component, effect, inject, input, output, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { OtapUpgradeTaskDTO, OtapUpgradeTaskInputParametersDTO } from '@app/shared/models/otap-upgrade-task.interface';

import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

@Component({
  selector: 'app-form-job-task',
  templateUrl: './form-job-task.component.html',
  styleUrls: ['./form-job-task.component.scss'],
  imports: [ReactiveFormsModule, MatFormField, MatLabel, MatInput]
})
export class FormJobTaskComponent {
  private readonly formBuilder = inject(FormBuilder);
  readonly task = input.required<OtapUpgradeTaskDTO>();
  readonly taskDataChanged = output<OtapUpgradeTaskInputParametersDTO[]>();
  readonly taskForm = signal<FormGroup>(this.formBuilder.group({}));

  constructor() {
    effect(onCleanup => {
      const task = this.task();
      const taskForm = this.formBuilder.group({});
      task.inputParameters.forEach(parameter => {
        taskForm.addControl(parameter.name, this.formBuilder.control(parameter.value, Validators.required));
      });
      this.taskForm.set(taskForm);

      const subscription = taskForm.valueChanges.subscribe(changedForm => {
        const changedParameters = task.inputParameters.map(param => {
        const formValue = changedForm[param.name];
        return { ...param, value: formValue };
      });
      this.taskDataChanged.emit(changedParameters);
      });
      onCleanup(() => subscription.unsubscribe());
    });
  }
}
